<template>
  <div>
    <PageAllow controller="Settings" action="processSetting" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-sheet class="page-card transparent-background-color">
        <!-- 要货流程设置 -->
        <v-card>
          <v-card-title>
            {{ $t("ProcessSetting.OrderProcess.title") }}
          </v-card-title>
          <v-divider />
          <v-card-text class="mt-8 pb-12">
            <v-row align="center" class="ml-5">
              <!-- 提交要货单0 -->
              <v-col class="ml-0" style="margin: auto">
                <v-row align="center">
                  <v-btn
                    depressed
                    fab
                    small
                    disabled
                    style="
                      border: 1px solid #009688;
                      background: #ffffff;
                      margin: auto;
                    "
                  >
                    <v-icon dark> fa-check </v-icon>
                  </v-btn>
                  <v-divider color="primary" style="max-width: 850px" />
                </v-row>
              </v-col>
              <!-- 要货确认1 -->
              <v-col class="ml-0" style="margin: auto">
                <v-row align="center">
                  <v-btn
                    depressed
                    fab
                    small
                    style="border: 1px solid #009688; background: #ffffff"
                    @click="OrderProcess_1 = !OrderProcess_1"
                  >
                    <v-icon v-if="OrderProcess_1" dark color="primary">
                      fa-check
                    </v-icon>
                  </v-btn>
                  <v-divider color="primary" style="max-width: 850px" />
                </v-row>
              </v-col>
              <!-- 财务审核2 -->
              <v-col class="ml-0" style="margin: auto">
                <v-row align="center">
                  <v-btn
                    color="primary"
                    fab
                    outlined
                    small
                    style="border: 1px solid #009688; background: #ffffff"
                    @click="OrderProcess_2 = !OrderProcess_2"
                  >
                    <v-icon v-if="OrderProcess_2" dark color="primary">
                      fa-check
                    </v-icon>
                  </v-btn>
                  <v-divider color="primary" style="max-width: 850px" />
                </v-row>
              </v-col>
              <!-- 出库确认3 -->
              <v-col class="ml-0" style="margin: auto">
                <v-row
                  align="center"
                  v-if="
                    accountInfo &&
                    accountInfo.version &&
                    accountInfo.version.stock_type == 1
                  "
                >
                  <v-btn
                    depressed
                    fab
                    small
                    disabled
                    style="
                      border: 1px solid #009688;
                      background: #ffffff;
                      margin: auto;
                    "
                  >
                    <v-icon dark> fa-check </v-icon>
                  </v-btn>
                  <v-divider color="primary" style="max-width: 850px" />
                </v-row>
                <v-row align="center" v-else>
                  <v-btn
                    v-if="
                      settings &&
                      (settings.order_to_purchase_setting == 1 ||
                        settings.stock_position_setting == 1)
                    "
                    depressed
                    fab
                    small
                    disabled
                    style="
                      border: 1px solid #009688;
                      background: #ffffff;
                      margin: auto;
                    "
                  >
                    <v-icon dark> fa-check </v-icon>
                  </v-btn>
                  <v-btn
                    v-else
                    color="primary"
                    fab
                    outlined
                    small
                    style="border: 1px solid #009688; background: #ffffff"
                    @click="OrderProcess_3 = !OrderProcess_3"
                  >
                    <v-icon v-if="OrderProcess_3" dark color="primary">
                      fa-check
                    </v-icon>
                  </v-btn>
                  <v-divider color="primary" style="max-width: 850px" />
                </v-row>
              </v-col>
              <!-- 配送确认4 -->
              <v-col class="ml-0" style="margin: auto">
                <v-row align="center">
                  <v-btn
                    color="primary"
                    fab
                    outlined
                    small
                    style="border: 1px solid #009688; background: #ffffff"
                    @click="OrderProcess_4 = !OrderProcess_4"
                  >
                    <v-icon v-if="OrderProcess_4" dark color="primary">
                      fa-check
                    </v-icon>
                  </v-btn>
                  <v-divider color="primary" style="max-width: 850px" />
                </v-row>
              </v-col>
              <!-- 收货确认5 -->
              <v-col class="ml-0" style="margin: auto">
                <v-row align="center">
                  <v-btn
                    v-if="
                      settings &&
                      (settings.order_to_purchase_setting ||
                        settings.push_platform == 1015 ||
                        settings.pay_success_order_auto_confirm == 1 ||
                        settings.order_paid_confirm == 1)
                    "
                    color="primary"
                    fab
                    small
                    style="border: 1px solid #009688; background: #ffffff"
                    disabled
                  >
                    <v-icon dark color="primary"> fa-check </v-icon>
                  </v-btn>
                  <v-btn
                    v-else
                    color="primary"
                    fab
                    outlined
                    small
                    style="border: 1px solid #009688; background: #ffffff"
                    @click="OrderProcess_5 = !OrderProcess_5"
                  >
                    <v-icon v-if="OrderProcess_5" dark color="primary">
                      fa-check
                    </v-icon>
                  </v-btn>
                  <v-divider color="primary" style="max-width: 850px" />
                </v-row>
              </v-col>
              <v-col class="ml-n3" style="margin: auto">
                <v-btn color="primary" fab small></v-btn>
              </v-col>
            </v-row>
            <v-row align="center" class="ml-5">
              <v-col class="ml-n2">
                <v-row>
                  <v-col>
                    <span class="text-center text-caption">
                      {{
                        $t(
                          "ProcessSetting.OrderProcess.account_created_order",
                          [$consts.shopName()]
                        )
                      }}
                    </span>
                  </v-col>
                  <v-col></v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-row>
                  <v-col>
                    <span class="text-center text-caption">
                      {{
                        $t("ProcessSetting.OrderProcess.account_confirm_order")
                      }}
                    </span>
                  </v-col>
                  <v-col></v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-row>
                  <v-col>
                    <span class="text-center text-caption">
                      {{ $t("ProcessSetting.OrderProcess.bill_check") }}
                    </span>
                  </v-col>
                  <v-col></v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-row>
                  <v-col>
                    <span class="text-center text-caption">
                      {{ $t("ProcessSetting.OrderProcess.stock_out_confirm") }}
                    </span>
                  </v-col>
                  <v-col></v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-row>
                  <v-col>
                    <span class="text-center text-caption">
                      {{
                        $t("ProcessSetting.OrderProcess.distribution_confirm")
                      }}
                    </span>
                  </v-col>
                  <v-col></v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-row>
                  <v-col>
                    <span class="text-center text-caption">
                      {{
                        $t(
                          "ProcessSetting.OrderProcess.account_receive_confirm",
                          [$consts.shopName()]
                        )
                      }}
                    </span>
                  </v-col>
                  <v-col></v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-row>
                  <v-col class="ml-2">
                    <span class="text-center text-caption">
                      {{ $t("ProcessSetting.OrderProcess.finish") }}
                    </span>
                  </v-col>
                  <v-col></v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <!-- 退货流程设置 -->
        <v-card class="my-5">
          <v-card-title>
            {{ $t("ProcessSetting.ReturnOrderProcess.title") }}
          </v-card-title>
          <v-divider />
          <v-card-text class="mt-8 pb-12">
            <v-row align="center" class="ml-5">
              <!-- 提交退货单0 -->
              <v-col class="ml-0" style="margin: auto">
                <v-row align="center">
                  <v-btn
                    depressed
                    fab
                    small
                    disabled
                    style="
                      border: 1px solid #009688;
                      background: #ffffff;
                      margin: auto;
                    "
                  >
                    <v-icon dark> fa-check </v-icon>
                  </v-btn>
                  <v-divider color="primary" style="max-width: 850px" />
                </v-row>
              </v-col>
              <!-- 退货单确认1 -->
              <v-col class="ml-0" style="margin: auto">
                <v-row align="center">
                  <v-btn
                    depressed
                    fab
                    small
                    disabled
                    style="
                      border: 1px solid #009688;
                      background: #ffffff;
                      margin: auto;
                    "
                  >
                    <v-icon dark> fa-check </v-icon>
                  </v-btn>
                  <v-divider color="primary" style="max-width: 850px" />
                </v-row>
              </v-col>
              <!-- 财务审核2 -->
              <v-col class="ml-0" style="margin: auto">
                <v-row align="center">
                  <v-btn
                    color="primary"
                    fab
                    outlined
                    small
                    style="border: 1px solid #009688; background: #ffffff"
                    @click="ReturnOrderProcess_2 = !ReturnOrderProcess_2"
                  >
                    <v-icon v-if="ReturnOrderProcess_2" dark color="primary">
                      fa-check
                    </v-icon>
                  </v-btn>
                  <v-divider color="primary" style="max-width: 850px" />
                </v-row>
              </v-col>
              <!-- 入库确认3 -->
              <v-col class="ml-0" style="margin: auto">
                <v-row
                  align="center"
                  v-if="
                    accountInfo &&
                    accountInfo.version &&
                    accountInfo.version.stock_type == 1
                  "
                >
                  <v-btn
                    depressed
                    fab
                    small
                    disabled
                    style="
                      border: 1px solid #009688;
                      background: #ffffff;
                      margin: auto;
                    "
                  >
                    <v-icon dark> fa-check </v-icon>
                  </v-btn>
                  <v-divider color="primary" style="max-width: 850px" />
                </v-row>
                <v-row align="center" v-else>
                  <v-btn
                    v-if="settings && settings.stock_position_setting"
                    depressed
                    fab
                    small
                    disabled
                    style="
                      border: 1px solid #009688;
                      background: #ffffff;
                      margin: auto;
                    "
                  >
                    <v-icon dark> fa-check </v-icon>
                  </v-btn>
                  <v-btn
                    v-else
                    depressed
                    fab
                    outlined
                    small
                    style="border: 1px solid #009688; background: #ffffff"
                    @click="ReturnOrderProcess_3 = !ReturnOrderProcess_3"
                  >
                    <v-icon v-if="ReturnOrderProcess_3" dark color="primary">
                      fa-check
                    </v-icon>
                  </v-btn>
                  <v-divider color="primary" style="max-width: 850px" />
                </v-row>
              </v-col>
              <!-- 收款确认4 -->
              <v-col class="ml-0" style="margin: auto">
                <v-row align="center">
                  <v-btn
                    color="primary"
                    fab
                    outlined
                    small
                    style="border: 1px solid #009688; background: #ffffff"
                    @click="ReturnOrderProcess_4 = !ReturnOrderProcess_4"
                  >
                    <v-icon v-if="ReturnOrderProcess_4" dark color="primary">
                      fa-check
                    </v-icon>
                  </v-btn>
                  <v-divider color="primary" style="max-width: 850px" />
                </v-row>
              </v-col>
              <v-col class="ml-n3" style="margin: auto">
                <v-btn color="primary" fab small></v-btn>
              </v-col>
            </v-row>
            <v-row align="center" class="ml-5">
              <v-col class="ml-n2">
                <v-row>
                  <v-col>
                    <span class="text-center text-caption">
                      {{
                        $t(
                          "ProcessSetting.ReturnOrderProcess.return_order_created",
                          [$consts.shopName()]
                        )
                      }}
                    </span>
                  </v-col>
                  <v-col></v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-row>
                  <v-col>
                    <span class="text-center text-caption">
                      {{
                        $t(
                          "ProcessSetting.ReturnOrderProcess.return_order_confirm"
                        )
                      }}
                    </span>
                  </v-col>
                  <v-col></v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-row>
                  <v-col>
                    <span class="text-center text-caption">
                      {{ $t("ProcessSetting.ReturnOrderProcess.bill_check") }}
                    </span>
                  </v-col>
                  <v-col></v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-row>
                  <v-col>
                    <span class="text-center text-caption">
                      {{
                        $t("ProcessSetting.ReturnOrderProcess.stock_in_confirm")
                      }}
                    </span>
                  </v-col>
                  <v-col></v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-row>
                  <v-col>
                    <span class="text-center text-caption">
                      {{
                        $t(
                          "ProcessSetting.ReturnOrderProcess.receipt_confirm",
                          [$consts.shopName()]
                        )
                      }}
                    </span>
                  </v-col>
                  <v-col></v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-row>
                  <v-col class="ml-2">
                    <span class="text-center text-caption">
                      {{ $t("ProcessSetting.ReturnOrderProcess.finish") }}
                    </span>
                  </v-col>
                  <v-col></v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <!-- 入库流程设置 -->
        <v-card
          class="my-5"
          v-if="
            accountInfo &&
            accountInfo.version &&
            (accountInfo.version.stock_type == 2 ||
              accountInfo.version.stock_type == 3)
          "
        >
          <v-card-title>
            {{ $t("ProcessSetting.StockINProcess.title") }}
          </v-card-title>
          <v-divider />
          <v-card-text class="mt-8 pb-12">
            <v-row align="center" class="ml-5">
              <!-- 提交入库单 -->
              <v-col class="ml-0" style="margin: auto">
                <v-row align="center">
                  <v-btn
                    depressed
                    fab
                    small
                    disabled
                    style="
                      border: 1px solid #009688;
                      background: #ffffff;
                      margin: auto;
                    "
                  >
                    <v-icon dark> fa-check </v-icon>
                  </v-btn>
                  <v-divider color="primary" style="max-width: 850px" />
                </v-row>
              </v-col>
              <!-- 财务审核 -->
              <v-col class="ml-0" style="margin: auto">
                <v-row align="center">
                  <v-btn
                    color="primary"
                    fab
                    outlined
                    small
                    style="border: 1px solid #009688; background: #ffffff"
                    @click="StockINProcess_1 = !StockINProcess_1"
                  >
                    <v-icon v-if="StockINProcess_1" dark color="primary">
                      fa-check
                    </v-icon>
                  </v-btn>
                  <v-divider color="primary" style="max-width: 850px" />
                </v-row>
              </v-col>
              <!-- 入库确认 -->
              <v-col class="ml-0" style="margin: auto">
                <v-row align="center">
                  <v-btn
                    v-if="settings && settings.stock_position_setting"
                    depressed
                    fab
                    small
                    disabled
                    style="
                      border: 1px solid #009688;
                      background: #ffffff;
                      margin: auto;
                    "
                  >
                    <v-icon dark> fa-check </v-icon>
                  </v-btn>
                  <v-btn
                    v-else
                    depressed
                    fab
                    outlined
                    small
                    style="border: 1px solid #009688; background: #ffffff"
                    @click="StockINProcess_2 = !StockINProcess_2"
                  >
                    <v-icon v-if="StockINProcess_2" dark color="primary">
                      fa-check
                    </v-icon>
                  </v-btn>
                  <v-divider color="primary" style="max-width: 850px" />
                </v-row>
              </v-col>
              <v-col class="ml-n3" style="margin: auto">
                <v-btn color="primary" fab small></v-btn>
              </v-col>
            </v-row>
            <v-row align="center" class="ml-5">
              <v-col class="ml-n2">
                <v-row>
                  <v-col>
                    <span class="text-center text-caption">
                      {{ $t("ProcessSetting.StockINProcess.stock_in_created") }}
                    </span>
                  </v-col>
                  <v-col></v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-row>
                  <v-col>
                    <span class="text-center text-caption">
                      {{ $t("ProcessSetting.StockINProcess.bill_check") }}
                    </span>
                  </v-col>
                  <v-col></v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-row>
                  <v-col>
                    <span class="text-center text-caption">
                      {{ $t("ProcessSetting.StockINProcess.stock_in_confirm") }}
                    </span>
                  </v-col>
                  <v-col></v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-row>
                  <v-col class="ml-2">
                    <span class="text-center text-caption">
                      {{ $t("ProcessSetting.StockINProcess.finish") }}
                    </span>
                  </v-col>
                  <v-col></v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <!-- 出库流程设置 -->
        <v-card
          class="my-5"
          v-if="
            accountInfo &&
            accountInfo.version &&
            (accountInfo.version.stock_type == 2 ||
              accountInfo.version.stock_type == 3)
          "
        >
          <v-card-title>
            {{ $t("ProcessSetting.StockOUTProcess.title") }}
          </v-card-title>
          <v-divider />
          <v-card-text class="mt-8 pb-12">
            <v-row align="center" class="ml-5">
              <v-col class="ml-0" style="margin: auto">
                <v-row align="center">
                  <v-btn
                    depressed
                    fab
                    small
                    disabled
                    style="
                      border: 1px solid #009688;
                      background: #ffffff;
                      margin: auto;
                    "
                  >
                    <v-icon dark> fa-check </v-icon>
                  </v-btn>
                  <v-divider color="primary" style="max-width: 850px" />
                </v-row>
              </v-col>
              <v-col class="ml-0" style="margin: auto">
                <v-row align="center">
                  <v-btn
                    color="primary"
                    fab
                    outlined
                    small
                    style="border: 1px solid #009688; background: #ffffff"
                    @click="StockOUTProcess_1 = !StockOUTProcess_1"
                  >
                    <v-icon v-if="StockOUTProcess_1" dark color="primary">
                      fa-check
                    </v-icon>
                  </v-btn>
                  <v-divider color="primary" style="max-width: 850px" />
                </v-row>
              </v-col>
              <v-col class="ml-0" style="margin: auto">
                <v-row align="center">
                  <v-btn
                    v-if="settings && settings.stock_position_setting"
                    depressed
                    fab
                    small
                    disabled
                    style="
                      border: 1px solid #009688;
                      background: #ffffff;
                      margin: auto;
                    "
                  >
                    <v-icon dark> fa-check </v-icon>
                  </v-btn>
                  <v-btn
                    v-else
                    depressed
                    fab
                    outlined
                    small
                    style="border: 1px solid #009688; background: #ffffff"
                    @click="StockOUTProcess_2 = !StockOUTProcess_2"
                  >
                    <v-icon v-if="StockOUTProcess_2" dark color="primary">
                      fa-check
                    </v-icon>
                  </v-btn>
                  <v-divider color="primary" style="max-width: 850px" />
                </v-row>
              </v-col>
              <v-col class="ml-n3" style="margin: auto">
                <v-btn color="primary" fab small></v-btn>
              </v-col>
            </v-row>
            <v-row align="center" class="ml-5">
              <v-col class="ml-n2">
                <v-row>
                  <v-col>
                    <span class="text-center text-caption">
                      {{
                        $t("ProcessSetting.StockOUTProcess.stock_out_created")
                      }}
                    </span>
                  </v-col>
                  <v-col></v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-row>
                  <v-col>
                    <span class="text-center text-caption">
                      {{ $t("ProcessSetting.StockOUTProcess.bill_check") }}
                    </span>
                  </v-col>
                  <v-col></v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-row>
                  <v-col>
                    <span class="text-center text-caption">
                      {{
                        $t("ProcessSetting.StockOUTProcess.stock_out_confirm")
                      }}
                    </span>
                  </v-col>
                  <v-col></v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-row>
                  <v-col class="ml-2">
                    <span class="text-center text-caption">
                      {{ $t("ProcessSetting.StockOUTProcess.finish") }}
                    </span>
                  </v-col>
                  <v-col></v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <!-- WMS流程设置 -->
        <v-card v-if="settings && settings.stock_position_setting">
          <v-card-title>
            {{ $t("ProcessSetting.WMSProcess.title") }}
          </v-card-title>
          <v-divider />
          <v-card-text class="mt-8 pb-12">
            <v-row align="center" class="ml-5">
              <v-col class="ml-0" style="margin: auto">
                <v-row align="center">
                  <v-btn
                    depressed
                    fab
                    small
                    disabled
                    style="
                      border: 1px solid #009688;
                      background: #ffffff;
                      margin: auto;
                    "
                  >
                    <v-icon dark> fa-check </v-icon>
                  </v-btn>
                  <v-divider color="primary" style="max-width: 850px" />
                </v-row>
              </v-col>
              <v-col class="ml-0" style="margin: auto">
                <v-row align="center">
                  <v-btn
                    color="primary"
                    fab
                    outlined
                    small
                    style="border: 1px solid #009688; background: #ffffff"
                    @click="WMSProcess_1 = !WMSProcess_1"
                  >
                    <v-icon v-if="WMSProcess_1" dark color="primary">
                      fa-check
                    </v-icon>
                  </v-btn>
                  <v-divider color="primary" style="max-width: 850px" />
                </v-row>
              </v-col>
              <v-col class="ml-0" style="margin: auto">
                <v-row align="center">
                  <v-btn
                    depressed
                    fab
                    small
                    disabled
                    style="
                      border: 1px solid #009688;
                      background: #ffffff;
                      margin: auto;
                    "
                  >
                    <v-icon dark> fa-check </v-icon>
                  </v-btn>
                  <v-divider color="primary" style="max-width: 850px" />
                </v-row>
              </v-col>
              <v-col class="ml-0" style="margin: auto">
                <v-row align="center">
                  <v-btn
                    depressed
                    fab
                    small
                    disabled
                    style="
                      border: 1px solid #009688;
                      background: #ffffff;
                      margin: auto;
                    "
                  >
                    <v-icon dark> fa-check </v-icon>
                  </v-btn>
                  <v-divider color="primary" style="max-width: 850px" />
                </v-row>
              </v-col>
              <v-col class="ml-0" style="margin: auto">
                <v-row align="center">
                  <v-btn
                    color="primary"
                    fab
                    outlined
                    small
                    style="border: 1px solid #009688; background: #ffffff"
                    @click="WMSProcess_4 = !WMSProcess_4"
                  >
                    <v-icon v-if="WMSProcess_4" dark color="primary">
                      fa-check
                    </v-icon>
                  </v-btn>
                  <v-divider color="primary" style="max-width: 850px" />
                </v-row>
              </v-col>
              <v-col class="ml-n3" style="margin: auto">
                <v-btn color="primary" fab small></v-btn>
              </v-col>
            </v-row>
            <v-row align="center" class="ml-5">
              <v-col class="ml-n2">
                <v-row>
                  <v-col>
                    <span class="text-center text-caption">
                      {{ $t("ProcessSetting.WMSProcess.wave_created") }}
                    </span>
                  </v-col>
                  <v-col></v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-row>
                  <v-col>
                    <span class="text-center text-caption">
                      {{ $t("ProcessSetting.WMSProcess.wave_receive") }}
                    </span>
                  </v-col>
                  <v-col></v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-row>
                  <v-col>
                    <span class="text-center text-caption">
                      {{ $t("ProcessSetting.WMSProcess.wave_pick") }}
                    </span>
                  </v-col>
                  <v-col></v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-row>
                  <v-col>
                    <span class="text-center text-caption">
                      {{ $t("ProcessSetting.WMSProcess.wave_sort") }}
                    </span>
                  </v-col>
                  <v-col></v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-row>
                  <v-col>
                    <span class="text-center text-caption">
                      {{ $t("ProcessSetting.WMSProcess.wave_package_confirm") }}
                    </span>
                  </v-col>
                  <v-col></v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-row>
                  <v-col class="ml-2">
                    <span class="text-center text-caption">
                      {{ $t("ProcessSetting.WMSProcess.finish") }}
                    </span>
                  </v-col>
                  <v-col></v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <!-- 生产计划流程设置 -->
        <v-card
          class="my-5"
          v-if="
            accountInfo &&
            accountInfo.version &&
            (accountInfo.version.stock_type == 2 ||
              accountInfo.version.stock_type == 3)
          "
        >
          <v-card-title>
            {{ $t("ProcessSetting.ProductionProcess.title") }}
          </v-card-title>
          <v-divider />
          <v-card-text class="mt-8 pb-12">
            <v-row align="center" class="ml-5">
              <v-col class="ml-0" style="margin: auto">
                <v-row align="center">
                  <v-btn
                    depressed
                    fab
                    small
                    disabled
                    style="
                      border: 1px solid #009688;
                      background: #ffffff;
                      margin: auto;
                    "
                  >
                    <v-icon dark> fa-check </v-icon>
                  </v-btn>
                  <v-divider color="primary" style="max-width: 850px" />
                </v-row>
              </v-col>
              <v-col class="ml-0" style="margin: auto">
                <v-row align="center">
                  <v-btn
                    color="primary"
                    fab
                    outlined
                    small
                    style="border: 1px solid #009688; background: #ffffff"
                    @click="ProductionProcess_2 = !ProductionProcess_2"
                  >
                    <v-icon v-if="ProductionProcess_2" dark color="primary">
                      fa-check
                    </v-icon>
                  </v-btn>
                  <v-divider color="primary" style="max-width: 850px" />
                </v-row>
              </v-col>
              <v-col class="ml-0" style="margin: auto">
                <v-row align="center">
                  <v-btn
                    v-if="settings && settings.stock_position_setting"
                    depressed
                    fab
                    small
                    disabled
                    style="
                      border: 1px solid #009688;
                      background: #ffffff;
                      margin: auto;
                    "
                  >
                    <v-icon dark> fa-check </v-icon>
                  </v-btn>
                  <v-btn
                    v-else
                    depressed
                    fab
                    outlined
                    small
                    style="border: 1px solid #009688; background: #ffffff"
                    @click="ProductionProcess_3 = !ProductionProcess_3"
                  >
                    <v-icon v-if="ProductionProcess_3" dark color="primary">
                      fa-check
                    </v-icon>
                  </v-btn>
                  <v-divider color="primary" style="max-width: 850px" />
                </v-row>
              </v-col>
              <v-col class="ml-0" style="margin: auto">
                <v-row align="center">
                  <v-btn
                    v-if="settings && settings.stock_position_setting"
                    depressed
                    fab
                    small
                    disabled
                    style="
                      border: 1px solid #009688;
                      background: #ffffff;
                      margin: auto;
                    "
                  >
                    <v-icon dark> fa-check </v-icon>
                  </v-btn>
                  <v-btn
                    v-else
                    depressed
                    fab
                    outlined
                    small
                    style="border: 1px solid #009688; background: #ffffff"
                    @click="ProductionProcess_4 = !ProductionProcess_4"
                  >
                    <v-icon v-if="ProductionProcess_4" dark color="primary">
                      fa-check
                    </v-icon>
                  </v-btn>
                  <v-divider color="primary" style="max-width: 850px" />
                </v-row>
              </v-col>
              <v-col class="ml-n3" style="margin: auto">
                <v-btn color="primary" fab small></v-btn>
              </v-col>
            </v-row>
            <v-row align="center" class="ml-5">
              <v-col class="ml-n2">
                <v-row>
                  <v-col>
                    <span class="text-center text-caption">
                      {{ $t("ProcessSetting.ProductionProcess.production_created") }}
                    </span>
                  </v-col>
                  <v-col></v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-row>
                  <v-col>
                    <span class="text-center text-caption">
                      {{ $t("ProcessSetting.ProductionProcess.bill_check") }}
                    </span>
                  </v-col>
                  <v-col></v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-row>
                  <v-col>
                    <span class="text-center text-caption">
                      {{ $t("ProcessSetting.ProductionProcess.production_out") }}
                    </span>
                  </v-col>
                  <v-col></v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-row>
                  <v-col class="ml-2">
                    <span class="text-center text-caption">
                      {{ $t("ProcessSetting.ProductionProcess.production_in") }}
                    </span>
                  </v-col>
                  <v-col></v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-row>
                  <v-col class="ml-2">
                    <span class="text-center text-caption">
                      {{ $t("ProcessSetting.ProductionProcess.finish") }}
                    </span>
                  </v-col>
                  <v-col></v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-sheet>
    </v-sheet>
    <v-sheet class="page-opts">
      <v-card>
        <v-card-title>
          <span>{{ $t("ProcessSetting.cutline") }}</span>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-row align="center">
            <v-col cols="2">
              <v-btn
                depressed
                fab
                x-small
                disabled
                style="
                  border: 1px solid #009688;
                  background: #ffffff;
                  margin: auto;
                "
              >
                <v-icon dark> fa-check </v-icon>
              </v-btn>
            </v-col>
            <v-col cols="10" class="pl-5">
              <span>{{ $t("ProcessSetting.processStatus_one") }}</span>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="2">
              <v-btn color="primary" fab outlined x-small>
                <v-icon dark> fa-check </v-icon>
              </v-btn>
            </v-col>
            <v-col cols="10" class="pl-5">
              <span>{{ $t("ProcessSetting.processStatus_two") }}</span>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="2">
              <v-btn color="primary" fab outlined x-small></v-btn>
            </v-col>
            <v-col cols="10" class="pl-5">
              <span>{{ $t("ProcessSetting.processStatus_three") }}</span>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="2">
              <v-btn
                fab
                x-small
                disabled
                depressed
                style="
                  border: 1px solid #009688;
                  background: #ffffff;
                  margin: auto;
                "
              ></v-btn>
            </v-col>
            <v-col cols="10" class="pl-5">
              <span>{{ $t("ProcessSetting.processStatus_four") }}</span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card class="mt-4">
        <v-card-title>
          <v-row dense>
            <v-col cols="12">
              <v-btn color="success" block @click="saveProcessSettings()">
                <v-icon small class="pe-1">fa-save</v-icon>
                {{ $t("CRUD.saveInfo", [$t("ProcessSetting.ObjectName")]) }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-sheet>
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import PageAllow from "@/components/PageAllow";
import Settings from "@/api/settings";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
  },
  computed: {
    items: () => [
      {
        text: i18n.t("SettingNav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("SettingNav.settings"),
        disabled: false,
        href: "/settings/bussiness-settings",
      },
      {
        text: i18n.t("SettingNav.processSetting"),
        disabled: true,
        href: "/settings/process-settings",
      },
    ],

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "accountInfo"]),
  },

  data: () => ({
    OrderProcess_1: false,
    OrderProcess_2: false,
    OrderProcess_3: false,
    OrderProcess_4: false,
    OrderProcess_5: false,
    ReturnOrderProcess_2: false,
    ReturnOrderProcess_3: false,
    ReturnOrderProcess_4: false,
    StockINProcess_1: false,
    StockINProcess_2: false,
    StockOUTProcess_1: false,
    StockOUTProcess_2: false,
    ProductionProcess_2: false,
    ProductionProcess_3: false,
    ProductionProcess_4: false,
    WMSProcess_1: false,
    WMSProcess_4: false,
  }),

  mounted() {
    this.getProcessSettings();
  },

  methods: {
    getProcessSettings() {
      Settings.fetch({
        keys: [
          "process_order",
          "process_return_order",
          "process_stock_in",
          "process_stock_out",
          "process_wms",
          "process_production_plan",
        ],
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            let processSettings = response.data.settings;
            //要货流程设置
            if (
              processSettings.process_order.indexOf(1) > -1 ||
              processSettings.process_order.indexOf("1") > -1
            ) {
              this.OrderProcess_1 = true;
            }
            if (
              processSettings.process_order.indexOf(2) > -1 ||
              processSettings.process_order.indexOf("2") > -1
            ) {
              this.OrderProcess_2 = true;
            }
            if (
              processSettings.process_order.indexOf(3) > -1 ||
              processSettings.process_order.indexOf("3") > -1
            ) {
              this.OrderProcess_3 = true;
            }
            if (
              processSettings.process_order.indexOf(4) > -1 ||
              processSettings.process_order.indexOf("4") > -1
            ) {
              this.OrderProcess_4 = true;
            }
            if (
              processSettings.process_order.indexOf(5) > -1 ||
              processSettings.process_order.indexOf("5") > -1
            ) {
              this.OrderProcess_5 = true;
            }
            //退货流程设置
            if (
              processSettings.process_return_order.indexOf(2) > -1 ||
              processSettings.process_return_order.indexOf("2") > -1
            ) {
              this.ReturnOrderProcess_2 = true;
            }
            if (
              processSettings.process_return_order.indexOf(3) > -1 ||
              processSettings.process_return_order.indexOf("3") > -1
            ) {
              this.ReturnOrderProcess_3 = true;
            }
            if (
              processSettings.process_return_order.indexOf(4) > -1 ||
              processSettings.process_return_order.indexOf("4") > -1
            ) {
              this.ReturnOrderProcess_4 = true;
            }
            //入库流程设置
            if (
              processSettings.process_stock_in.indexOf(1) > -1 ||
              processSettings.process_stock_in.indexOf("1") > -1
            ) {
              this.StockINProcess_1 = true;
            }
            if (
              processSettings.process_stock_in.indexOf(2) > -1 ||
              processSettings.process_stock_in.indexOf("2") > -1
            ) {
              this.StockINProcess_2 = true;
            }
            //出库流程设置
            if (
              processSettings.process_stock_out.indexOf(1) > -1 ||
              processSettings.process_stock_out.indexOf("1") > -1
            ) {
              this.StockOUTProcess_1 = true;
            }
            if (
              processSettings.process_stock_out.indexOf(2) > -1 ||
              processSettings.process_stock_out.indexOf("2") > -1
            ) {
              this.StockOUTProcess_2 = true;
            }
            //生产计划流程设置
            if (
              processSettings.process_production_plan.indexOf(2) > -1 ||
              processSettings.process_production_plan.indexOf("2") > -1
            ) {
              this.ProductionProcess_2 = true;
            }
            if (
              processSettings.process_production_plan.indexOf(3) > -1 ||
              processSettings.process_production_plan.indexOf("3") > -1
            ) {
              this.ProductionProcess_3 = true;
            }
            if (
              processSettings.process_production_plan.indexOf(4) > -1 ||
              processSettings.process_production_plan.indexOf("4") > -1
            ) {
              this.ProductionProcess_4 = true;
            }
            //wms流程设置
            if (
              processSettings.process_wms.indexOf(1) > -1 ||
              processSettings.process_wms.indexOf("1") > -1
            ) {
              this.WMSProcess_1 = true;
            }
            if (
              processSettings.process_wms.indexOf(4) > -1 ||
              processSettings.process_wms.indexOf("4") > -1
            ) {
              this.WMSProcess_4 = true;
            }
          }
        }.bind(this)
      );
    },

    saveProcessSettings() {
      let process_order = [0, 6];
      let process_return_order = [0, 1, 5];
      let process_stock_in = [0, 3];
      let process_stock_out = [0, 3];
      let process_wms = [0, 2, 3, 5];
      let process_production_plan = [0, 5]
      //要货流程设置
      // if (this.OrderProcess_1) {
      //   process_order.push(1);
      // }
      if (
        this.settings &&
        (this.settings.push_platform == 1015||this.settings.pay_success_order_auto_confirm  == 1 ||
          this.settings.order_paid_confirm  == 1)
      ) {
        process_order.push(1);
      } else {
        if (this.OrderProcess_1) {
          process_order.push(1);
        }
      }
      
      // if (this.OrderProcess_2) {
      //   process_order.push(2);
      // }
      if (
        this.settings &&
        (this.settings.push_platform == 1015)
      ) {
        process_order.push(2);
      } else {
        if (this.OrderProcess_2) {
          process_order.push(2);
        }
      }

      if (
        this.settings &&
        this.settings.order_to_purchase_setting == 1
      ) {
        process_order.push(3);
      } else {
        if (this.OrderProcess_3) {
          process_order.push(3);
        }
      }

      if (this.OrderProcess_4) {
        process_order.push(4);
      }
      if (
        this.settings &&
        this.settings.order_to_purchase_setting
      ) {
        process_order.push(5);
      } else {
        if (this.OrderProcess_5) {
          process_order.push(5);
        }
      }

      //退货流程设置
      if (this.ReturnOrderProcess_2) {
        process_return_order.push(2);
      }
      if (
        (this.settings && this.settings.stock_position_setting) ||
        (this.accountInfo &&
          this.accountInfo.version &&
          this.accountInfo.version.stock_type == 1)
      ) {
        process_return_order.push(3);
      } else {
        if (this.ReturnOrderProcess_3) {
          process_return_order.push(3);
        }
      }

      if (this.ReturnOrderProcess_4) {
        process_return_order.push(4);
      }
      //入库流程设置
      if (this.StockINProcess_1) {
        process_stock_in.push(1);
      }
      if (this.settings && this.settings.stock_position_setting) {
        process_stock_in.push(2);
      } else {
        if (this.StockINProcess_2) {
          process_stock_in.push(2);
        }
      }

      //出库流程设置
      if (this.StockOUTProcess_1) {
        process_stock_out.push(1);
      }
      if (this.settings && this.settings.stock_position_setting) {
        process_stock_out.push(2);
      } else {
        if (this.StockOUTProcess_2) {
          process_stock_out.push(2);
        }
      }

      //生产计划流程设置
      if (this.ProductionProcess_2) {
        process_production_plan.push(2);
      }
      if ((this.settings && this.settings.stock_position_setting) &&
        (
          this.accountInfo &&
          this. accountInfo.version &&
          (this.accountInfo.version.stock_type == 2 || this.accountInfo.version.stock_type == 3)
        )
      ) {
        process_production_plan.push(3);
        process_production_plan.push(4);
      } else {
        if (this.ProductionProcess_3) {
          process_production_plan.push(3);
        }
        if (this.ProductionProcess_4) {
          process_production_plan.push(4);
        }
      }

      //wms流程设置
      if (this.settings && this.settings.stock_position_setting) {
        if (this.WMSProcess_1) {
          process_wms.push(1);
        }
        if (this.WMSProcess_4) {
          process_wms.push(4);
        }
      } else {
        process_wms = [];
      }

      Settings.batchSave([
        {
          setting_key: "process_order",
          setting_value: process_order,
        },
        {
          setting_key: "process_return_order",
          setting_value: process_return_order,
        },
        {
          setting_key: "process_stock_in",
          setting_value: process_stock_in,
        },
        {
          setting_key: "process_stock_out",
          setting_value: process_stock_out,
        },
        {
          setting_key: "process_wms",
          setting_value: process_wms,
        },
        {
          setting_key: "process_production_plan",
          setting_value: process_production_plan
        }
      ]).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$snackbar.success(i18n.t("BusinessSetting.saveSuccess"));
            this.getProcessSettings();
          } else if (
            response.data.error &&
            response.data.data &&
            "ERR184" == response.data.error.code
          ) {
            let errData = response.data.data;
            errData.forEach((err) => {
              this.$snackbar.error(err);
            });
          }
        }.bind(this)
      );
    },
  },
};
</script>